<template>
  <!-- active-tabss -->
  <div class="active-tabss">
    <div class="tl">
      <ul class="tl_btns">
        <li
          :class="lead_status == 1 ? 'active original-active' : 'active'"
          id="tab1"
        >
          <a class="active-drop" v-on:click="updateStatus(1)">
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="19"
                viewBox="0 0 27 19"
                fill="none"
              >
                <path
                  d="M1.44727 10.2649L8.85779 17.6402L25.5315 1.0459"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <defs>
                  <clipPath id="clip0">
                    <rect
                      x="0.773438"
                      y="0.0400391"
                      width="25.6"
                      height="18.7733"
                      fill="white"
                    />
                  </clipPath>
                </defs></svg
            ></span>
            <p>Active</p>
          </a>
          <div class="active-dropdown">
            <div class="cal-email-box">
              <a href="#" v-on:click="updateContacted('call')">Call</a>
            </div>
            <div class="cal-email-box">
              <a href="#" v-on:click.stop.prevent="activaTab('text')">Text</a>
            </div>
            <div class="cal-email-box">
              <a href="#" v-on:click.stop.prevent="activaTab('email')">Email</a>
            </div>
            <div class="respon-time">
              <h6>
                Response Time
                <span class="restime">
                  <img
                    class="img-fluid"
                    src="../../assets/img/Timer.svg"
                    alt=""
                  /><!--{{response_time.d}}{{response_time.h}}-->{{
                    response_time.m
                  }}:{{ response_time.s }}</span
                >
              </h6>
            </div>
          </div>
          <!-- <div class="active-dropdown">
                        <div class="cal-email-box">
                            <a href="#" v-on:click="updateContacted('call')">Call</a>
                        </div>
                        <div class="cal-email-box">
                            <a href="#" v-on:click="updateContacted('sms')">Text</a>
                        </div>
                        <div class="cal-email-box">
                            <a href="#" v-on:click="updateContacted('email')">Email</a>
                        </div>
                        <div class="respon-time">
                            <h6>Response Time <span class="restime" v-if="lead_touch_response_time"> <img class="img-fluid" src="../../assets/img/Timer.svg" alt="">{{lead_touch_response_time | timeDifference(lead_created)}}</span></h6>
                        </div>
                    </div> -->
        </li>
        <li
          id="tab2"
          data-toggle="modal"
          data-backdrop="static"
          data-keyboard="false"
          data-target="#contactedModel1"
          :class="
            lead_status == 2
              ? 'active original-active'
              : lead_status > 2
              ? 'active'
              : ''
          "
        >
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="25"
              viewBox="0 0 40 25"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.2036 1.3987C25.354 0.877949 24.3506 0.642932 23.3563 0.753339L23.356 0.753371L21.1313 0.997843L21.1281 0.998207C19.9502 1.13517 18.8645 1.72393 18.12 2.65911L13.8321 7.82648L13.8317 7.82698C13.3803 8.36935 13.5568 9.20892 14.2175 9.5067C15.989 10.3174 18.0567 10.0731 19.5962 8.88474L19.5962 8.88468L21.7972 7.18507L21.7973 7.18519L21.8069 7.17739C21.8074 7.17694 21.8075 7.17693 21.8079 7.1768C21.8085 7.17659 21.8108 7.17596 21.815 7.17606C21.8241 7.1763 21.8369 7.17994 21.8488 7.18962L21.8511 7.19146L22.7192 7.88842C22.9345 8.06129 23.2492 8.02687 23.4221 7.81154C23.595 7.5962 23.5606 7.2815 23.3452 7.10862L22.4794 6.4135L22.478 6.41241C22.1177 6.12068 21.5771 6.08017 21.1819 6.39675L18.9851 8.09315L18.985 8.0932C17.7371 9.05647 16.064 9.25255 14.6323 8.59682L14.6286 8.59515C14.582 8.57426 14.5637 8.51064 14.6004 8.46667L14.601 8.46586L18.8929 3.29366L18.8929 3.29374L18.8996 3.28532C19.4752 2.56048 20.3193 2.09939 21.2421 1.99169L21.2436 1.99151L23.4659 1.74732L23.4665 1.74725C24.2313 1.66227 25.0114 1.84209 25.677 2.24883L30.6758 5.44898L30.6758 5.45657V17.684C30.6758 18.6326 31.4499 19.4067 32.3985 19.4067H38.8791C39.1552 19.4067 39.3791 19.1829 39.3791 18.9067V4.23383C39.3791 3.95769 39.1552 3.73383 38.8791 3.73383H32.3985C31.8189 3.73383 31.3045 4.0228 30.9919 4.464L26.2119 1.4039L26.212 1.40382L26.2036 1.3987ZM14.9684 4.38495C15.2072 4.24626 15.2883 3.94025 15.1496 3.70146C15.011 3.46268 14.7049 3.38153 14.4662 3.52022L12.1616 4.85874H10.6211C10.345 4.85874 10.1211 5.08259 10.1211 5.35874C10.1211 5.63488 10.345 5.85874 10.6211 5.85874H12.2963C12.3845 5.85874 12.4711 5.8354 12.5474 5.7911L14.9684 4.38495ZM0.558105 3.73383C0.281963 3.73383 0.0581055 3.95769 0.0581055 4.23383V18.9067C0.0581055 19.1829 0.281963 19.4067 0.558105 19.4067H7.03864C7.98729 19.4067 8.76138 18.6326 8.76138 17.684V17.4014H10.3396L13.7151 22.9687L13.716 22.9702C14.4795 24.2196 15.8396 24.9824 17.3095 24.9824C18.1632 24.9824 18.7902 24.3435 18.9037 23.609C19.379 23.7442 19.8429 23.7969 20.2924 23.7578C21.0052 23.6959 21.6448 23.406 22.2008 22.9138C22.4272 22.7161 22.578 22.4658 22.6562 22.1968C23.1533 22.3455 23.6382 22.4047 24.1073 22.3639C24.8201 22.3019 25.4598 22.0121 26.0158 21.5199C26.1935 21.3646 26.3247 21.1769 26.4107 20.9732C27.4407 21.14 28.3705 20.8748 29.1603 20.1607C29.7317 19.6595 29.8193 18.8229 29.4729 18.1992L29.4729 18.1992L29.4694 18.1931L28.3811 16.2978C28.2436 16.0584 27.938 15.9757 27.6986 16.1132C27.4591 16.2507 27.3764 16.5563 27.5139 16.7958L28.6002 18.6875C28.7401 18.9423 28.6821 19.2511 28.4995 19.41L28.4995 19.41L28.4922 19.4166C27.9249 19.9307 27.2779 20.122 26.4909 19.9723C26.4569 19.8277 26.4033 19.6874 26.3306 19.5565L26.3306 19.5565L26.3274 19.5508L24.1142 15.687C23.977 15.4474 23.6715 15.3644 23.4319 15.5016C23.1922 15.6389 23.1092 15.9444 23.2465 16.184L25.4578 20.0446C25.5023 20.1256 25.5268 20.212 25.5337 20.2974C25.5268 20.3412 25.526 20.3849 25.5306 20.4275C25.5131 20.5621 25.4519 20.6849 25.3573 20.7673L25.3573 20.7673L25.3541 20.7701C24.9444 21.1331 24.5025 21.3258 24.0207 21.3677C23.6041 21.4039 23.1313 21.3295 22.5965 21.1184C22.5729 21.061 22.5459 21.0049 22.5157 20.9505L22.5157 20.9504L22.5125 20.9448L20.2993 17.0809C20.162 16.8413 19.8565 16.7583 19.6169 16.8955C19.3773 17.0328 19.2943 17.3383 19.4316 17.5779L21.6081 21.3779C21.5874 21.5198 21.6292 21.6634 21.72 21.7717C21.7126 21.9255 21.6486 22.0687 21.5423 22.1613L21.5423 22.1612L21.5391 22.1641C21.1295 22.527 20.6876 22.7197 20.2057 22.7616C19.7545 22.8008 19.2374 22.7102 18.6468 22.4568L16.6 18.669C16.4687 18.4261 16.1654 18.3356 15.9224 18.4668C15.6795 18.5981 15.589 18.9015 15.7203 19.1444L17.8478 23.0817L17.8477 23.0817L17.8536 23.092C17.9008 23.1746 17.9222 23.2692 17.9222 23.3697C17.9222 23.69 17.6602 23.9824 17.3095 23.9824C16.1875 23.9824 15.1513 23.4006 14.5697 22.4495L14.5693 22.4487L11.0487 16.6422C10.958 16.4927 10.7959 16.4014 10.6211 16.4014H8.76138V5.45657C8.76138 4.50792 7.98729 3.73383 7.03864 3.73383H0.558105ZM7.76123 16.9014L7.76138 16.8891V5.45657C7.76138 5.06021 7.435 4.73383 7.03864 4.73383H1.05811V18.4067H7.03864C7.435 18.4067 7.76138 18.0804 7.76138 17.684V16.9138L7.76123 16.9014ZM4.74 14.9328C4.74 15.2975 4.44438 15.5931 4.07971 15.5931C3.71505 15.5931 3.41943 15.2975 3.41943 14.9328C3.41943 14.5681 3.71505 14.2725 4.07971 14.2725C4.44438 14.2725 4.74 14.5681 4.74 14.9328ZM32.3985 4.73383C32.0022 4.73383 31.6758 5.06021 31.6758 5.45657V17.684C31.6758 18.0804 32.0022 18.4067 32.3985 18.4067H38.3791V4.73383H32.3985ZM36.0173 14.9328C36.0173 15.2975 35.7217 15.5931 35.3571 15.5931C34.9924 15.5931 34.6968 15.2975 34.6968 14.9328C34.6968 14.5681 34.9924 14.2725 35.3571 14.2725C35.7217 14.2725 36.0173 14.5681 36.0173 14.9328ZM27.214 15.5931C27.5786 15.5931 27.8743 15.2975 27.8743 14.9328C27.8743 14.5681 27.5786 14.2725 27.214 14.2725C26.8493 14.2725 26.5537 14.5681 26.5537 14.9328C26.5537 15.2975 26.8493 15.5931 27.214 15.5931ZM24.0863 8.65003C24.335 8.52996 24.6339 8.6342 24.754 8.88287L26.6492 12.8079C26.7693 13.0565 26.665 13.3555 26.4164 13.4755C26.1677 13.5956 25.8688 13.4914 25.7487 13.2427L23.8535 9.3177C23.7334 9.06903 23.8376 8.77011 24.0863 8.65003Z"
                fill="#A2A8B8"
              /></svg
          ></span>
          <p>Contacted</p>
        </li>

        <li
          id="tab3"
          :class="
            lead_status == 3
              ? 'active original-active'
              : lead_status > 3
              ? 'active'
              : ''
          "
        >
          <a v-on:click="updateStatus(3)" class="active-drop"
            ><span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="31"
                viewBox="0 0 30 31"
                fill="none"
              >
                <path
                  d="M15.8407 27.9259H2.55906C1.94573 27.9259 1.44873 27.4196 1.44873 26.795V4.55382C1.44873 3.92913 1.94573 3.42291 2.55906 3.42291H26.3518C26.9651 3.42291 27.4621 3.92913 27.4621 4.55382V16.9076"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8213 0.751831V5.06004"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M27.4621 8.40967H1.44873"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.95687 17.1015H5.25578C4.95969 17.1015 4.72705 16.8646 4.72705 16.563V14.3227C4.72705 14.0211 4.95969 13.7842 5.25578 13.7842H8.95687C9.25295 13.7842 9.48559 14.0211 9.48559 14.3227V16.563C9.48559 16.8538 9.25295 17.1015 8.95687 17.1015Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.306 17.1015H12.6049C12.3088 17.1015 12.0762 16.8646 12.0762 16.563V14.3227C12.0762 14.0211 12.3088 13.7842 12.6049 13.7842H16.306C16.6021 13.7842 16.8347 14.0211 16.8347 14.3227V16.563C16.8347 16.8538 16.6021 17.1015 16.306 17.1015Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19.4253 16.1752V14.3227C19.4253 14.0211 19.6579 13.7842 19.954 13.7842H23.6445C23.9406 13.7842 24.1733 14.0211 24.1733 14.3227V15.5398"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.95687 23.6931H5.25578C4.95969 23.6931 4.72705 23.4561 4.72705 23.1545V20.9143C4.72705 20.6127 4.95969 20.3757 5.25578 20.3757H8.95687C9.25295 20.3757 9.48559 20.6127 9.48559 20.9143V23.1545C9.48559 23.4453 9.25295 23.6931 8.95687 23.6931Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.6881 23.6931H12.6049C12.3194 23.6931 12.0762 23.4561 12.0762 23.1545V20.9143C12.0762 20.6235 12.3194 20.3757 12.6049 20.3757H15.3649"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.403 22.3683C28.4981 22.7883 28.551 23.2407 28.551 23.693C28.551 26.9242 25.9814 29.5414 22.8196 29.5414C19.6472 29.5414 17.0776 26.9242 17.0776 23.693C17.0776 20.4726 19.6472 17.8554 22.8196 17.8554C23.9617 17.8554 25.0297 18.2001 25.9285 18.8032"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21.1489 23.5207L22.714 25.1148L28.5511 19.1694"
                  fill="white"
                />
                <path
                  d="M21.1489 23.5207L22.714 25.1148L28.5511 19.1694"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.5293 0.751831V5.06004"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                /></svg
            ></span>
            <p>Scheduled</p></a
          >
          <div class="active-dropdown Sched-hover">
            <div class="active-meeting">
              <!-- active-meeting -->
              <div class="media" v-for="apt in appointments" :key="apt.ap_id">
                <p class="mr-3">{{ apt.ap_date_time | formatDate("MM/DD") }}</p>
                <div
                  class="media-body"
                  :class="
                    apt.ap_status == 2
                      ? aptColors[1]
                      : apt.ap_status == 1
                      ? aptColors[2]
                      : apt.time_status == 'past'
                      ? aptColors[1]
                      : aptColors[0]
                  "
                >
                  <!-- <h5 class="mt-0">{{apt.ap_description}}</h5> -->
                  <h5 class="mt-0">
                    {{ apt.c_first_name }} {{ apt.c_last_name }}
                  </h5>
                  <p v-if="$storage.get('auth').user.user_type == 1">
                    Assigned to: {{ apt.name }}
                  </p>
                  <p>Description: {{ apt.ap_description }}</p>
                  <p>{{ apt.ap_date_time | formatDate("hh:mm A") }}</p>
                  <div class="appo-menu" :id="'LTmainAppt' + apt.ap_id">
                    <ul>
                      <li>
                        <a
                          data-toggle="tooltip"
                          title="Confirmed"
                          :id="'LTcomp' + apt.ap_id"
                          class="okay"
                          v-on:click.stop.prevent="
                            updateAptStatus(apt.ap_id, 3)
                          "
                          :class="apt.ap_status == 3 ? 'okay-bg' : ''"
                          href="#"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                          >
                            <g clip-path="url(#clip0)">
                              <path
                                d="M0.769569 4.64628C0.574307 4.45102 0.257724 4.45102 0.0624622 4.64628C-0.1328 4.84155 -0.1328 5.15813 0.0624622 5.35339L0.769569 4.64628ZM2.91602 7.49984L2.56246 7.85339C2.75772 8.04865 3.07431 8.04865 3.26957 7.85339L2.91602 7.49984ZM7.8529 3.27006C8.04816 3.0748 8.04816 2.75821 7.8529 2.56295C7.65764 2.36769 7.34106 2.36769 7.14579 2.56295L7.8529 3.27006ZM2.8529 4.64628C2.65764 4.45102 2.34106 4.45102 2.1458 4.64628C1.95053 4.84155 1.95053 5.15813 2.1458 5.35339L2.8529 4.64628ZM4.6458 7.14628C4.45053 7.34155 4.45053 7.65813 4.6458 7.85339C4.84106 8.04865 5.15764 8.04865 5.3529 7.85339L4.6458 7.14628ZM9.93623 3.27006C10.1315 3.0748 10.1315 2.75821 9.93623 2.56295C9.74097 2.36769 9.42439 2.36769 9.22913 2.56295L9.93623 3.27006ZM0.0624622 5.35339L2.56246 7.85339L3.26957 7.14628L0.769569 4.64628L0.0624622 5.35339ZM5.3529 7.85339L9.93623 3.27006L9.22913 2.56295L4.6458 7.14628L5.3529 7.85339ZM3.26957 7.85339L4.31124 6.81172L3.60413 6.10462L2.56246 7.14628L3.26957 7.85339ZM4.31124 6.81172L7.8529 3.27006L7.14579 2.56295L3.60413 6.10462L4.31124 6.81172ZM2.1458 5.35339L3.60413 6.81172L4.31124 6.10462L2.8529 4.64628L2.1458 5.35339Z"
                                fill="#3151A1"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="10" height="10" fill="white" />
                              </clipPath>
                            </defs></svg
                        ></a>
                      </li>
                      <!-- <li>
                        <a
                          data-toggle="tooltip"
                          title="Confirmed"
                          :id="'LTcomp' + apt.ap_id"
                          class="okay"
                          v-on:click="updateAptStatus(apt.ap_id, 1)"
                          :class="apt.ap_status == 1 ? 'okay-bg' : ''"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                          >
                            <g clip-path="url(#clip0)">
                              <path
                                d="M0.769569 4.64628C0.574307 4.45102 0.257724 4.45102 0.0624622 4.64628C-0.1328 4.84155 -0.1328 5.15813 0.0624622 5.35339L0.769569 4.64628ZM2.91602 7.49984L2.56246 7.85339C2.75772 8.04865 3.07431 8.04865 3.26957 7.85339L2.91602 7.49984ZM7.8529 3.27006C8.04816 3.0748 8.04816 2.75821 7.8529 2.56295C7.65764 2.36769 7.34106 2.36769 7.14579 2.56295L7.8529 3.27006ZM2.8529 4.64628C2.65764 4.45102 2.34106 4.45102 2.1458 4.64628C1.95053 4.84155 1.95053 5.15813 2.1458 5.35339L2.8529 4.64628ZM4.6458 7.14628C4.45053 7.34155 4.45053 7.65813 4.6458 7.85339C4.84106 8.04865 5.15764 8.04865 5.3529 7.85339L4.6458 7.14628ZM9.93623 3.27006C10.1315 3.0748 10.1315 2.75821 9.93623 2.56295C9.74097 2.36769 9.42439 2.36769 9.22913 2.56295L9.93623 3.27006ZM0.0624622 5.35339L2.56246 7.85339L3.26957 7.14628L0.769569 4.64628L0.0624622 5.35339ZM5.3529 7.85339L9.93623 3.27006L9.22913 2.56295L4.6458 7.14628L5.3529 7.85339ZM3.26957 7.85339L4.31124 6.81172L3.60413 6.10462L2.56246 7.14628L3.26957 7.85339ZM4.31124 6.81172L7.8529 3.27006L7.14579 2.56295L3.60413 6.10462L4.31124 6.81172ZM2.1458 5.35339L3.60413 6.81172L4.31124 6.10462L2.8529 4.64628L2.1458 5.35339Z"
                                fill="#3151A1"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="10" height="10" fill="white" />
                              </clipPath>
                            </defs></svg
                        ></a>
                      </li> -->
                      <li v-if="apt.ap_status == '0'">
                        <a
                          data-toggle="tooltip"
                          title="Reschedule"
                          v-on:click.stop.prevent="reScheduleApt(apt)"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                          >
                            <g clip-path="url(#clip0)">
                              <path
                                d="M3.41634 1.25C3.41634 0.973858 3.19248 0.75 2.91634 0.75C2.6402 0.75 2.41634 0.973858 2.41634 1.25H3.41634ZM7.58301 1.25C7.58301 0.973858 7.35915 0.75 7.08301 0.75C6.80687 0.75 6.58301 0.973858 6.58301 1.25H7.58301ZM1.66634 2.58333H2.91634V1.58333H1.66634V2.58333ZM2.91634 2.58333H7.08301V1.58333H2.91634V2.58333ZM7.08301 2.58333H8.33301V1.58333H7.08301V2.58333ZM8.33301 9.08333H1.66634V10.0833H8.33301V9.08333ZM1.33301 8.75V4.16667H0.333008V8.75H1.33301ZM1.33301 4.16667V2.91667H0.333008V4.16667H1.33301ZM8.66634 2.91667V4.16667H9.66634V2.91667H8.66634ZM8.66634 4.16667V8.75H9.66634V4.16667H8.66634ZM0.833008 4.66667H9.16634V3.66667H0.833008V4.66667ZM3.41634 2.08333V1.25H2.41634V2.08333H3.41634ZM7.58301 2.08333V1.25H6.58301V2.08333H7.58301ZM1.66634 9.08333C1.48225 9.08333 1.33301 8.93409 1.33301 8.75H0.333008C0.333008 9.48638 0.929962 10.0833 1.66634 10.0833V9.08333ZM8.33301 10.0833C9.06939 10.0833 9.66634 9.48638 9.66634 8.75H8.66634C8.66634 8.9341 8.5171 9.08333 8.33301 9.08333V10.0833ZM8.33301 2.58333C8.5171 2.58333 8.66634 2.73257 8.66634 2.91667H9.66634C9.66634 2.18029 9.06939 1.58333 8.33301 1.58333V2.58333ZM1.66634 1.58333C0.929962 1.58333 0.333008 2.18029 0.333008 2.91667H1.33301C1.33301 2.73257 1.48225 2.58333 1.66634 2.58333V1.58333Z"
                                fill="#3151A1"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="10" height="10" fill="white" />
                              </clipPath>
                            </defs></svg
                        ></a>
                      </li>
                      <li>
                        <a
                          data-toggle="tooltip"
                          title="Shown"
                          :id="'LTshow' + apt.ap_id"
                          class="okay"
                          v-on:click.stop.prevent="
                            updateAptStatus(apt.ap_id, 1)
                          "
                          :class="apt.ap_status == 1 ? 'okay-bg' : ''"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="15"
                            viewBox="0 0 34 47"
                            fill="none"
                          >
                            <path
                              d="M18.3125 9.40841C20.595 9.40841 22.4454 7.52612 22.4454 5.2042C22.4454 2.88229 20.595 1 18.3125 1C16.03 1 14.1797 2.88229 14.1797 5.2042C14.1797 7.52612 16.03 9.40841 18.3125 9.40841Z"
                              stroke="#A2A8B8"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M16.6154 10.9098C12.4678 11.9008 8.54894 13.1696 5.84783 14.3633C5.35337 14.581 4.94746 14.9639 4.70392 15.4519L1.16886 22.5465C0.807241 23.2747 1.0434 24.1606 1.71499 24.596C2.49728 25.1065 3.53787 24.8062 3.95115 23.9579L7.16886 17.2912L11.6264 15.8498C11.7297 15.8198 11.8405 15.8198 11.929 15.8648C12.0914 15.9474 12.1726 16.1201 12.143 16.2927L8.822 34.8813C8.75558 35.2567 8.59322 35.6095 8.35706 35.9098L2.9327 42.6516C2.42348 43.2822 2.3792 44.1831 2.82938 44.8588C3.49359 45.8723 4.92532 45.9774 5.72237 45.0615L11.8035 38.087C12.1061 37.7417 12.298 37.3137 12.3497 36.8558L13.0286 31.06C13.0803 30.5945 13.619 30.3768 13.9733 30.6771L18.1947 34.2582C18.6523 34.6411 18.9327 35.1966 18.9844 35.7972L19.6928 44.063C19.7814 45.1216 20.7556 45.8648 21.7814 45.6621C22.6301 45.4894 23.2353 44.7161 23.1984 43.8378L22.7777 34.2207C22.7556 33.6201 22.4973 33.0495 22.0619 32.6366C22.0619 32.6366 16.3423 28.1996 16.8441 27.569C18.3202 25.6921 18.7334 19.6336 18.7334 19.6336C18.8294 19.2657 19.3091 19.1831 19.5157 19.4984L21.8847 22.9969C22.2464 23.5225 22.8072 23.8753 23.4272 23.9579L31.0139 24.9489C31.9142 25.069 32.7039 24.3558 32.7039 23.4324C32.7039 22.6966 32.1873 22.066 31.4788 21.9309L24.6523 20.6396C24.1283 20.542 23.6633 20.2116 23.4124 19.7387C21.191 15.4894 19.1246 10.3092 16.6154 10.9098Z"
                              stroke="#A2A8B8"
                              stroke-miterlimit="10"
                            />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          data-toggle="tooltip"
                          title="Missed"
                          :id="'LTmiss' + apt.ap_id"
                          v-on:click="updateAptStatus(apt.ap_id, 2)"
                          :class="apt.ap_status == 2 ? 'notok-bg' : ''"
                          class="notok"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                          >
                            <path
                              d="M7.53033 1.53033C7.82322 1.23744 7.82322 0.762563 7.53033 0.46967C7.23744 0.176777 6.76256 0.176777 6.46967 0.46967L7.53033 1.53033ZM0.46967 6.46967C0.176777 6.76256 0.176777 7.23744 0.46967 7.53033C0.762563 7.82322 1.23744 7.82322 1.53033 7.53033L0.46967 6.46967ZM1.53033 0.46967C1.23744 0.176777 0.762563 0.176777 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L1.53033 0.46967ZM6.46967 7.53033C6.76256 7.82322 7.23744 7.82322 7.53033 7.53033C7.82322 7.23744 7.82322 6.76256 7.53033 6.46967L6.46967 7.53033ZM6.46967 0.46967L0.46967 6.46967L1.53033 7.53033L7.53033 1.53033L6.46967 0.46967ZM0.46967 1.53033L6.46967 7.53033L7.53033 6.46967L1.53033 0.46967L0.46967 1.53033Z"
                              fill="#3151A1"
                            /></svg
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="media not-found" v-if="appointments.length == 0">
                No Appointment Found.
              </div>

              <!-- <div class="media">
                                <p class="mr-3">14:00</p>
                                <div class="media-body green-meeting">
                                    <h5 class="mt-0">Meeting Call with ninja</h5>
                                    <p>10:05 AM - 11:30 AM</p>
                                    <div class="appo-menu">
                                        <ul>
                                        <li><a class="okay" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><g clip-path="url(#clip0)"><path d="M0.769569 4.64628C0.574307 4.45102 0.257724 4.45102 0.0624622 4.64628C-0.1328 4.84155 -0.1328 5.15813 0.0624622 5.35339L0.769569 4.64628ZM2.91602 7.49984L2.56246 7.85339C2.75772 8.04865 3.07431 8.04865 3.26957 7.85339L2.91602 7.49984ZM7.8529 3.27006C8.04816 3.0748 8.04816 2.75821 7.8529 2.56295C7.65764 2.36769 7.34106 2.36769 7.14579 2.56295L7.8529 3.27006ZM2.8529 4.64628C2.65764 4.45102 2.34106 4.45102 2.1458 4.64628C1.95053 4.84155 1.95053 5.15813 2.1458 5.35339L2.8529 4.64628ZM4.6458 7.14628C4.45053 7.34155 4.45053 7.65813 4.6458 7.85339C4.84106 8.04865 5.15764 8.04865 5.3529 7.85339L4.6458 7.14628ZM9.93623 3.27006C10.1315 3.0748 10.1315 2.75821 9.93623 2.56295C9.74097 2.36769 9.42439 2.36769 9.22913 2.56295L9.93623 3.27006ZM0.0624622 5.35339L2.56246 7.85339L3.26957 7.14628L0.769569 4.64628L0.0624622 5.35339ZM5.3529 7.85339L9.93623 3.27006L9.22913 2.56295L4.6458 7.14628L5.3529 7.85339ZM3.26957 7.85339L4.31124 6.81172L3.60413 6.10462L2.56246 7.14628L3.26957 7.85339ZM4.31124 6.81172L7.8529 3.27006L7.14579 2.56295L3.60413 6.10462L4.31124 6.81172ZM2.1458 5.35339L3.60413 6.81172L4.31124 6.10462L2.8529 4.64628L2.1458 5.35339Z" fill="#3151A1"/></g><defs><clipPath id="clip0"><rect width="10" height="10" fill="white"/></clipPath></defs></svg></a></li>
                                        <li><a href="#" data-toggle="modal" data-target="#exampleModal20"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><g clip-path="url(#clip0)"><path d="M3.41634 1.25C3.41634 0.973858 3.19248 0.75 2.91634 0.75C2.6402 0.75 2.41634 0.973858 2.41634 1.25H3.41634ZM7.58301 1.25C7.58301 0.973858 7.35915 0.75 7.08301 0.75C6.80687 0.75 6.58301 0.973858 6.58301 1.25H7.58301ZM1.66634 2.58333H2.91634V1.58333H1.66634V2.58333ZM2.91634 2.58333H7.08301V1.58333H2.91634V2.58333ZM7.08301 2.58333H8.33301V1.58333H7.08301V2.58333ZM8.33301 9.08333H1.66634V10.0833H8.33301V9.08333ZM1.33301 8.75V4.16667H0.333008V8.75H1.33301ZM1.33301 4.16667V2.91667H0.333008V4.16667H1.33301ZM8.66634 2.91667V4.16667H9.66634V2.91667H8.66634ZM8.66634 4.16667V8.75H9.66634V4.16667H8.66634ZM0.833008 4.66667H9.16634V3.66667H0.833008V4.66667ZM3.41634 2.08333V1.25H2.41634V2.08333H3.41634ZM7.58301 2.08333V1.25H6.58301V2.08333H7.58301ZM1.66634 9.08333C1.48225 9.08333 1.33301 8.93409 1.33301 8.75H0.333008C0.333008 9.48638 0.929962 10.0833 1.66634 10.0833V9.08333ZM8.33301 10.0833C9.06939 10.0833 9.66634 9.48638 9.66634 8.75H8.66634C8.66634 8.9341 8.5171 9.08333 8.33301 9.08333V10.0833ZM8.33301 2.58333C8.5171 2.58333 8.66634 2.73257 8.66634 2.91667H9.66634C9.66634 2.18029 9.06939 1.58333 8.33301 1.58333V2.58333ZM1.66634 1.58333C0.929962 1.58333 0.333008 2.18029 0.333008 2.91667H1.33301C1.33301 2.73257 1.48225 2.58333 1.66634 2.58333V1.58333Z" fill="#3151A1"/></g><defs><clipPath id="clip0"><rect width="10" height="10" fill="white"/></clipPath></defs></svg></a></li>
                                        <li><a class="notok" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M7.53033 1.53033C7.82322 1.23744 7.82322 0.762563 7.53033 0.46967C7.23744 0.176777 6.76256 0.176777 6.46967 0.46967L7.53033 1.53033ZM0.46967 6.46967C0.176777 6.76256 0.176777 7.23744 0.46967 7.53033C0.762563 7.82322 1.23744 7.82322 1.53033 7.53033L0.46967 6.46967ZM1.53033 0.46967C1.23744 0.176777 0.762563 0.176777 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L1.53033 0.46967ZM6.46967 7.53033C6.76256 7.82322 7.23744 7.82322 7.53033 7.53033C7.82322 7.23744 7.82322 6.76256 7.53033 6.46967L6.46967 7.53033ZM6.46967 0.46967L0.46967 6.46967L1.53033 7.53033L7.53033 1.53033L6.46967 0.46967ZM0.46967 1.53033L6.46967 7.53033L7.53033 6.46967L1.53033 0.46967L0.46967 1.53033Z" fill="#3151A1"/>
                                            </svg></a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div> -->
              <!-- active-meeting -->
            </div>
          </div>
        </li>
        <li
          :class="
            lead_status == 4
              ? 'active original-active'
              : lead_status > 4
              ? 'active'
              : ''
          "
          id="tab4"
        >
          <a
            v-on:click="updateStatus(4)"
            style="display: flow-root"
            class="active-drop"
            ><span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="47"
                viewBox="0 0 34 47"
                fill="none"
              >
                <path
                  d="M18.3125 9.40841C20.595 9.40841 22.4454 7.52612 22.4454 5.2042C22.4454 2.88229 20.595 1 18.3125 1C16.03 1 14.1797 2.88229 14.1797 5.2042C14.1797 7.52612 16.03 9.40841 18.3125 9.40841Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                />
                <path
                  d="M16.6154 10.9098C12.4678 11.9008 8.54894 13.1696 5.84783 14.3633C5.35337 14.581 4.94746 14.9639 4.70392 15.4519L1.16886 22.5465C0.807241 23.2747 1.0434 24.1606 1.71499 24.596C2.49728 25.1065 3.53787 24.8062 3.95115 23.9579L7.16886 17.2912L11.6264 15.8498C11.7297 15.8198 11.8405 15.8198 11.929 15.8648C12.0914 15.9474 12.1726 16.1201 12.143 16.2927L8.822 34.8813C8.75558 35.2567 8.59322 35.6095 8.35706 35.9098L2.9327 42.6516C2.42348 43.2822 2.3792 44.1831 2.82938 44.8588C3.49359 45.8723 4.92532 45.9774 5.72237 45.0615L11.8035 38.087C12.1061 37.7417 12.298 37.3137 12.3497 36.8558L13.0286 31.06C13.0803 30.5945 13.619 30.3768 13.9733 30.6771L18.1947 34.2582C18.6523 34.6411 18.9327 35.1966 18.9844 35.7972L19.6928 44.063C19.7814 45.1216 20.7556 45.8648 21.7814 45.6621C22.6301 45.4894 23.2353 44.7161 23.1984 43.8378L22.7777 34.2207C22.7556 33.6201 22.4973 33.0495 22.0619 32.6366C22.0619 32.6366 16.3423 28.1996 16.8441 27.569C18.3202 25.6921 18.7334 19.6336 18.7334 19.6336C18.8294 19.2657 19.3091 19.1831 19.5157 19.4984L21.8847 22.9969C22.2464 23.5225 22.8072 23.8753 23.4272 23.9579L31.0139 24.9489C31.9142 25.069 32.7039 24.3558 32.7039 23.4324C32.7039 22.6966 32.1873 22.066 31.4788 21.9309L24.6523 20.6396C24.1283 20.542 23.6633 20.2116 23.4124 19.7387C21.191 15.4894 19.1246 10.3092 16.6154 10.9098Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                /></svg
            ></span>
            <p>Visit</p></a
          >
          <div class="active-dropdown visit-drodn">
            <div class="cal-email-box">
              <label class="check2 democheck containerw">
                Visit
                <input
                  id="visit"
                  type="checkbox"
                  :checked="
                    current_sub_status.visit == 1 ||
                    current_sub_status.demo == 1
                  "
                  value="visit"
                  name="visit"
                  v-on:change="onChnageHandelerVisit('visit', $event)"
                />
                <span class="checkmarks"></span>
              </label>
            </div>
            <div class="cal-email-box">
              <label class="check2 democheck containerw">
                Demo
                <input
                  id="demo"
                  type="checkbox"
                  :checked="current_sub_status.demo == 1"
                  value="demo"
                  name="demo"
                  v-on:change="onChnageHandeler('demo', $event)"
                />
                <span class="checkmarks"></span>
              </label>
            </div>
            <div class="cal-email-box desked-box">
              <label class="check2 containerw desked">
                Desked
                <input
                  id="desk"
                  type="checkbox"
                  :checked="current_sub_status.desk == 1"
                  value="desk"
                  name="desk"
                  v-on:change="onChnageHandelerdesk('desk', $event)"
                />
                <span class="checkmarks"></span>
              </label>
            </div>
            <div
              class="visitd-btn"
              v-bind:class="current_sub_status.desk == 1 ? 'sds' : ''"
            >
              <a
                class="soldbtn"
                v-bind:class="current_status == 6 ? 'active' : ''"
                v-on:click="updateStatus(6)"
                >Sold</a
              >
              <a
                class="lostbtn"
                v-bind:class="current_status == 7 ? 'active' : ''"
                data-toggle="modal"
                data-target="#whyLostModel"
                >Lost</a
              >
              <a
                class="missing"
                data-toggle="modal"
                data-target="#contactedModel1"
                >Missing Steps</a
              >
            </div>
          </div>
        </li>
        <li
          :class="
            lead_status == 5
              ? 'active original-active'
              : lead_status > 5
              ? 'active'
              : ''
          "
          id="tab5"
        >
          <a
            v-on:click="updateStatus(5)"
            style="display: flow-root"
            class="active-drop"
          >
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="35"
                viewBox="0 0 37 35"
                fill="none"
              >
                <path
                  d="M8.66294 21.1944L5.53809 24.4386"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.94727 21.1944H8.65148H17.2138C18.0712 21.1944 18.7819 21.9077 18.7819 22.805V23.6908C18.7819 24.5652 18.0825 25.2899 17.2138 25.2899H13.7957"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.796 25.3013H18.974C19.3011 25.3013 19.617 25.2093 19.8878 25.0367L24.4453 22.1261C25.235 21.62 26.2841 21.85 26.8031 22.6438C27.3333 23.4721 27.1077 24.5766 26.2841 25.1058L20.779 28.6261C20.5082 28.7986 20.1811 28.8907 19.8652 28.8907H13.2545C12.792 28.8907 12.352 29.0748 12.0361 29.4084L11.1675 30.2942"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.4912 23.7619L2.12207 26.1779L9.70806 33.914L12.0772 31.498L4.4912 23.7619Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.3009 21.2058H3.55264C2.17635 21.2058 1.0708 20.0669 1.0708 18.6749V17.4669H35.7827V18.6749C35.7827 20.0669 34.6659 21.2058 33.3009 21.2058Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.0095 15.7873C12.7229 15.7873 14.1118 14.3708 14.1118 12.6236C14.1118 10.8763 12.7229 9.4599 11.0095 9.4599C9.29617 9.4599 7.90723 10.8763 7.90723 12.6236C7.90723 14.3708 9.29617 15.7873 11.0095 15.7873Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25.4041 15.7873C27.1174 15.7873 28.5064 14.3708 28.5064 12.6236C28.5064 10.8763 27.1174 9.4599 25.4041 9.4599C23.6907 9.4599 22.3018 10.8763 22.3018 12.6236C22.3018 14.3708 23.6907 15.7873 25.4041 15.7873Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.35821 14.2457H4.59033V9.40242C4.59033 8.05641 5.66203 6.9635 6.98192 6.9635H7.61366H28.5965H29.2395C30.5481 6.9635 31.6085 8.05641 31.6085 9.40242V14.2457H28.055"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.7419 14.2457H13.6719"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.6079 6.96348H7.60254L12.8144 1.63697C13.2092 1.18831 13.7733 0.923706 14.3599 0.923706H21.8393C22.4259 0.923706 22.9899 1.1768 23.3848 1.63697L28.6079 6.96348Z"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.4512 0.935242V6.4113"
                  stroke="#A2A8B8"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                /></svg
            ></span>
            <p>Demo</p>
          </a>
          <div class="active-dropdown visit-drodn">
            <div class="cal-email-box">
              <label class="check2 democheck containerw">
                Demo
                <input
                  id="demo1"
                  type="checkbox"
                  :checked="current_sub_status.demo == 1"
                  value="demo"
                  name="demo1"
                  v-on:change="onChnageHandeler('demo', $event)"
                />
                <span class="checkmarks"></span>
              </label>
            </div>
            <div class="cal-email-box desked-box">
              <label class="check2 containerw desked">
                Desked
                <input
                  id="desk1"
                  type="checkbox"
                  :checked="current_sub_status.desk == 1"
                  value="desk"
                  name="desk1"
                  v-on:change="onChnageHandelerdesk('desk', $event)"
                />
                <span class="checkmarks"></span>
              </label>
            </div>
            <div
              class="visitd-btn"
              v-bind:class="current_sub_status.desk == 1 ? 'sds' : ''"
            >
              <a
                class="soldbtn"
                v-bind:class="current_status == 6 ? 'active' : ''"
                v-on:click="updateStatus(6)"
                >Sold</a
              >
              <a
                class="lostbtn"
                v-bind:class="current_status == 7 ? 'active' : ''"
                data-toggle="modal"
                data-target="#whyLostModel"
                >Lost</a
              >
              <a
                class="missing"
                data-toggle="modal"
                data-target="#contactedModel1"
                >Missing Steps</a
              >
            </div>
          </div>
        </li>
        <!-- <li :class="lead_status == 5 ? 'active original-active':lead_status > 5 ? 'active':''" v-on:click="updateStatus(5)" id="tab5">
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="37" height="35" viewBox="0 0 37 35" fill="none">
                <path d="M8.66294 21.1944L5.53809 24.4386" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.94727 21.1944H8.65148H17.2138C18.0712 21.1944 18.7819 21.9077 18.7819 22.805V23.6908C18.7819 24.5652 18.0825 25.2899 17.2138 25.2899H13.7957" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.796 25.3013H18.974C19.3011 25.3013 19.617 25.2093 19.8878 25.0367L24.4453 22.1261C25.235 21.62 26.2841 21.85 26.8031 22.6438C27.3333 23.4721 27.1077 24.5766 26.2841 25.1058L20.779 28.6261C20.5082 28.7986 20.1811 28.8907 19.8652 28.8907H13.2545C12.792 28.8907 12.352 29.0748 12.0361 29.4084L11.1675 30.2942" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.4912 23.7619L2.12207 26.1779L9.70806 33.914L12.0772 31.498L4.4912 23.7619Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M33.3009 21.2058H3.55264C2.17635 21.2058 1.0708 20.0669 1.0708 18.6749V17.4669H35.7827V18.6749C35.7827 20.0669 34.6659 21.2058 33.3009 21.2058Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.0095 15.7873C12.7229 15.7873 14.1118 14.3708 14.1118 12.6236C14.1118 10.8763 12.7229 9.4599 11.0095 9.4599C9.29617 9.4599 7.90723 10.8763 7.90723 12.6236C7.90723 14.3708 9.29617 15.7873 11.0095 15.7873Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M25.4041 15.7873C27.1174 15.7873 28.5064 14.3708 28.5064 12.6236C28.5064 10.8763 27.1174 9.4599 25.4041 9.4599C23.6907 9.4599 22.3018 10.8763 22.3018 12.6236C22.3018 14.3708 23.6907 15.7873 25.4041 15.7873Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.35821 14.2457H4.59033V9.40242C4.59033 8.05641 5.66203 6.9635 6.98192 6.9635H7.61366H28.5965H29.2395C30.5481 6.9635 31.6085 8.05641 31.6085 9.40242V14.2457H28.055" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22.7419 14.2457H13.6719" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M28.6079 6.96348H7.60254L12.8144 1.63697C13.2092 1.18831 13.7733 0.923706 14.3599 0.923706H21.8393C22.4259 0.923706 22.9899 1.1768 23.3848 1.63697L28.6079 6.96348Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.4512 0.935242V6.4113" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg></span>
                <p>Demo</p></li> -->

        <li
          :class="
            lead_status == 6
              ? 'active original-active'
              : lead_status > 6
              ? 'active'
              : ''
          "
          id="tab6"
          class="sold"
        >
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="39"
              height="30"
              viewBox="0 0 39 30"
              fill="none"
            >
              <path
                d="M29.1307 16.3099H9.69912C8.77757 16.3099 8.13248 15.4153 8.44844 14.5718L9.47531 11.8114C10.1731 9.95828 11.9767 8.71863 14.0172 8.71863H24.8257C26.8531 8.71863 28.6699 9.95828 29.3677 11.8114L30.3945 14.5718C30.6973 15.4153 30.0522 16.3099 29.1307 16.3099Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M30.3815 14.5719L33.7385 18.5081C33.9624 18.7765 34.0808 19.1088 34.0808 19.4538V24.4508C34.0808 25.2942 33.3831 25.9716 32.5142 25.9716H6.40795C5.53906 25.9716 4.84131 25.2942 4.84131 24.4508V19.4538C4.84131 19.1088 4.95979 18.7765 5.1836 18.5081L8.43536 14.5719"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M5.05225 23.7606H33.7783"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M10.1591 29.2943H7.82885C7.34175 29.2943 6.95996 28.9109 6.95996 28.4509V25.9716H11.0411V28.4509C11.028 28.9237 10.6462 29.2943 10.1591 29.2943Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M6.94775 27.1089H7.81665"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M6.94775 28.2464H7.81665"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M10.1338 27.1089H11.029"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M10.1338 28.2464H11.029"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M31.0663 29.2943H28.7229C28.2358 29.2943 27.854 28.9109 27.854 28.4509V25.9716H31.9352V28.4509C31.9352 28.9237 31.5534 29.2943 31.0663 29.2943Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M27.854 27.1089H28.7229"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M27.854 28.2464H28.7229"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M31.04 27.1089H31.9353"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M31.04 28.2464H31.9353"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M34.2261 15.3515H32.6594C32.3698 15.3515 32.146 15.1214 32.146 14.853V13.7923C32.146 13.5111 32.383 13.2939 32.6594 13.2939H34.2261C34.5157 13.2939 34.7395 13.5239 34.7395 13.7923V14.853C34.7395 15.1214 34.5025 15.3515 34.2261 15.3515Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M30.3818 14.5719L32.1328 14.7892"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M4.89433 15.3515H6.46097C6.7506 15.3515 6.9744 15.1214 6.9744 14.853V13.7923C6.9744 13.5111 6.73743 13.2939 6.46097 13.2939H4.89433C4.6047 13.2939 4.38089 13.5239 4.38089 13.7923V14.853C4.36773 15.1214 4.6047 15.3515 4.89433 15.3515Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M8.72507 14.5719L6.97412 14.7892"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
              />
              <path
                d="M11.1211 21.7158H8.13264C7.48756 21.7158 6.97412 21.2174 6.97412 20.5912V20.1055C6.97412 19.4154 7.61921 18.8787 8.33012 18.9937L11.3186 19.4793C11.8715 19.5688 12.2796 20.0416 12.2796 20.5912C12.2796 21.2174 11.7662 21.7158 11.1211 21.7158Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M27.9857 21.7158H30.9741C31.6192 21.7158 32.1327 21.2174 32.1327 20.5912V20.1055C32.1327 19.4154 31.4876 18.8787 30.7767 18.9937L27.7882 19.4921C27.2353 19.5815 26.8271 20.0544 26.8271 20.6039C26.8271 21.2174 27.3537 21.7158 27.9857 21.7158Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M23.7066 23.7607H15.123V20.1567C15.123 19.6711 15.5312 19.2749 16.0314 19.2749H22.7983C23.2985 19.2749 23.7066 19.6711 23.7066 20.1567V23.7607Z"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M1.45801 6.82721L19.4151 0.705627L37.6882 6.82721"
                stroke="#A2A8B8"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.4926 21.9587C16.5979 22.0098 16.7559 22.0609 16.9138 22.0609C17.085 22.0609 17.1771 21.9842 17.1771 21.882C17.1771 21.7798 17.0982 21.7159 16.8875 21.652C16.6111 21.5625 16.4267 21.4091 16.4267 21.1663C16.4267 20.8852 16.6637 20.6679 17.0718 20.6679C17.2561 20.6679 17.401 20.7062 17.5063 20.7446L17.4273 21.0385C17.3615 21.013 17.243 20.9618 17.0718 20.9618C16.9007 20.9618 16.8217 21.0385 16.8217 21.1152C16.8217 21.2174 16.9138 21.2686 17.1377 21.3452C17.4404 21.4475 17.5721 21.6008 17.5721 21.8309C17.5721 22.112 17.3483 22.3421 16.8875 22.3421C16.69 22.3421 16.5057 22.291 16.4136 22.2398L16.4926 21.9587Z"
                fill="#A2A8B8"
              />
              <path
                d="M19.3888 21.4986C19.3888 22.0353 19.0465 22.3676 18.5594 22.3676C18.0592 22.3676 17.7695 21.997 17.7695 21.5369C17.7695 21.0513 18.0987 20.6807 18.5858 20.6807C19.0992 20.6679 19.3888 21.0513 19.3888 21.4986ZM18.1645 21.5241C18.1645 21.8436 18.3225 22.0737 18.5726 22.0737C18.8359 22.0737 18.9807 21.8309 18.9807 21.5114C18.9807 21.2174 18.8359 20.9618 18.5726 20.9618C18.3093 20.9618 18.1645 21.2046 18.1645 21.5241Z"
                fill="#A2A8B8"
              />
              <path
                d="M19.6392 20.6935H20.0209V22.0226H20.6924V22.3293H19.6392V20.6935Z"
                fill="#A2A8B8"
              />
              <path
                d="M20.916 20.7191C21.0608 20.6935 21.2451 20.6807 21.4295 20.6807C21.7454 20.6807 21.9561 20.7318 22.1272 20.8596C22.2983 20.9874 22.4168 21.1919 22.4168 21.4731C22.4168 21.7926 22.2983 22.0098 22.1404 22.1376C21.9561 22.2782 21.6928 22.3549 21.3636 22.3549C21.1662 22.3549 21.0213 22.3421 20.9292 22.3293V20.7191H20.916ZM21.311 22.061C21.3373 22.0737 21.39 22.0737 21.4426 22.0737C21.7849 22.0737 22.0087 21.8948 22.0087 21.4986C22.0087 21.1536 21.8112 20.9747 21.4821 20.9747C21.4031 20.9747 21.3373 20.9874 21.311 20.9874V22.061Z"
                fill="#A2A8B8"
              /></svg
          ></span>
          <p>Sold</p>
          <div class="active-dropdown visit-drodn deal-summary">
            <div class="container">
              <div class="add-member add-lead">
                <br />
                <h6 class="text">Deal Summary</h6>
                <br />
                <form @submit.prevent="adddeal">
                  <div class="row">
                    <div class="col-md-6">
                      <label>Sold Date</label>
                    </div>

                    <div class="col-md-6 text">
                      <date-picker
                        v-model="solddate"
                        valueType="format"
                        format="YYYY-MM-DD"
                      ></date-picker>
                      <!-- <input
                        type="text"
                        class="form-control"
                        v-model="deal.solddate"
                      /> -->
                    </div>

                    <div class="col-md-6 text">
                      <label>MSRP</label>
                    </div>
                    <div class="col-md-6 text">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.msrp"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6 text">
                      <label>Net Trade</label>
                    </div>
                    <div class="col-md-6 text">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.net_trade"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6 text">
                      <label>Rebates</label>
                    </div>
                    <div class="col-md-6 text">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.rebates"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-12 text-center radiodiv">
                      <label class="containerw" style="width:102px !important;">
                        Cash
                        <input
                          class="radiobtn"
                          type="radio"
                          name="option"
                          :checked="cashdealstatus"
                          @change="changeValue('cash')"
                        />
                        <span class="checkmark"></span>
                      </label>
                      <label class="containerw" style="width:102px !important;">
                        Finance
                        <input
                          class="radiobtn"
                          type="radio"
                          name="option"
                          :checked="finance"
                          @change="changeValue('Finance')"
                        />
                        <span class="checkmark"></span>
                      </label>
                      <label class="containerw" style="width:102px !important;">
                        Lease
                        <input
                          class="radiobtn"
                          type="radio"
                          :checked="lease"
                          name="option"
                          @change="changeValue('Lease')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </div>

                    <div class="col-md-6 text" v-if="cashdealstatus == true">
                      <label>Selling Price</label>
                    </div>
                    <div class="col-md-6 text" v-if="cashdealstatus == true">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.l_cash_selling_price"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6 text" v-if="cashdealstatus == true">
                      <label>Cash Down</label>
                    </div>
                    <div class="col-md-6 text" v-if="cashdealstatus == true">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.l_cash_cashdown"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6" v-if="finance == true">
                      <label>Selling Price</label>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.selling_price"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6" v-if="finance == true">
                      <label>Cash Down</label>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <vue-numeric
                        currency="$"
                        separator=","
                        v-model="deal.cash_down"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <label>Terms Expiration</label>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <input
                        type="number"
                        class="form-control"
                        v-model="deal.terms"
                      />
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <label>APR</label>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <vue-numeric
                        currency="%"
                        v-bind:precision="2"
                        currency-symbol-position="suffix"
                        separator=","
                        v-model="deal.apr"
                        class="form-control"
                      ></vue-numeric>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <label>DTFP</label>
                    </div>

                    <div class="col-md-6 text" v-if="finance == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.dtfp"
                      />
                    </div>
                    <!--LEASE SECTION -->
                    <div class="col-md-6" v-if="lease == true">
                      <label>Cap Cost</label>
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.cap_cost"
                      />
                    </div>

                    <div class="col-md-6" v-if="lease == true">
                      <label>Cap Cost Reduction</label>
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.cap_cost_reduction"
                      />
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <label>Terms Expiration</label>
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.terms"
                      />
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <label>Money Factor</label>
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.money_factor"
                      />
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <label>Residual Rate</label>
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.residual_rate"
                      />
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <label>Mileage Allowance</label>
                    </div>

                    <div class="col-md-6 text" v-if="lease == true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="deal.mileage_allowance"
                      />
                    </div>
                  </div>
                  <center>
                    <button type="submit" class="rem-btn afteremil-btn">
                      Mark As Sold
                    </button>
                  </center>
                </form>
              </div>
            </div>
          </div>
        </li>

        <!-- <li :class="lead_status == 6 ? 'active original-active':lead_status > 6 ? 'active':''" v-on:click="updateStatus(6)" id="tab6"><span><svg xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30" fill="none">
                <path d="M16.2357 12.79L21.6544 20.8426C22.1765 21.6084 23.2208 21.8173 23.9866 21.2952L31.5751 16.1898C32.3409 15.6792 32.5498 14.6233 32.0276 13.8575L25.1817 3.69314C23.975 1.89465 21.9909 0.919983 19.9835 0.919983C18.7884 0.919983 17.5701 1.26808 16.5026 1.98747C14.4952 3.34505 13.5206 5.65408 13.7874 7.90509" stroke="#A2A8B8" stroke-miterlimit="10"/>
                <path d="M19.5425 7.80066C20.5679 7.80066 21.3991 6.96947 21.3991 5.94415C21.3991 4.91883 20.5679 4.08765 19.5425 4.08765C18.5172 4.08765 17.686 4.91883 17.686 5.94415C17.686 6.96947 18.5172 7.80066 19.5425 7.80066Z" stroke="#A2A8B8" stroke-miterlimit="10"/>
                <path d="M16.2472 13.0568C16.2472 8.93771 12.4878 5.70042 8.21782 6.57066C5.71154 7.0812 3.68098 9.11175 3.14724 11.618C2.77594 13.3701 3.10082 15.0178 3.88984 16.3753C4.15671 16.8279 4.17992 17.3964 3.98267 17.8838L0.907825 25.1705C0.791793 25.449 0.791793 25.7623 0.907825 26.0408L1.78967 28.0713C2.01013 28.5703 2.56708 28.8371 3.10082 28.6979L5.1894 28.1178C5.64192 27.9901 5.90879 27.5376 5.81597 27.0851L5.5839 26.0292C5.49108 25.5999 5.72314 25.1822 6.12925 25.0197L6.75582 24.776C7.18514 24.6136 7.41721 24.1495 7.28957 23.7085L7.06911 22.9775C6.92987 22.5134 7.19675 22.0145 7.67248 21.8868L8.82119 21.562L9.2157 20.6221C9.44776 20.0884 9.93509 19.7055 10.5153 19.6242C13.7525 19.1833 16.2472 16.4101 16.2472 13.0568Z" stroke="#A2A8B8" stroke-miterlimit="10"/>
                <path d="M10.2249 13.8576C11.3463 13.8576 12.2554 12.9484 12.2554 11.827C12.2554 10.7056 11.3463 9.79645 10.2249 9.79645C9.10345 9.79645 8.19434 10.7056 8.19434 11.827C8.19434 12.9484 9.10345 13.8576 10.2249 13.8576Z" stroke="#A2A8B8" stroke-miterlimit="10"/>
                <path d="M10.2134 11.9663C10.2134 11.9663 13.2302 13.0105 16.073 10.8408C19.0666 8.55493 19.5423 5.94421 19.5423 5.94421" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg></span><p>Delivered</p></li> -->

        <li
          data-toggle="modal"
          data-target="#whyLostModel"
          :class="
            lead_status == 7
              ? 'active original-active'
              : lead_status > 7
              ? 'active'
              : ''
          "
          id="tab7"
          class="lost"
        >
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="31"
              viewBox="0 0 26 31"
              fill="none"
            >
              <path
                d="M13.0732 1.34668C13.0732 1.07054 12.8494 0.84668 12.5732 0.84668C12.2971 0.84668 12.0732 1.07054 12.0732 1.34668H13.0732ZM10.0132 29.0067C9.73708 29.0067 9.51322 29.2305 9.51322 29.5067C9.51322 29.7828 9.73708 30.0067 10.0132 30.0067V29.0067ZM15.1332 30.0067C15.4094 30.0067 15.6332 29.7828 15.6332 29.5067C15.6332 29.2305 15.4094 29.0067 15.1332 29.0067V30.0067ZM24.9781 9.64812L25.4068 9.39088L24.9781 9.64812ZM24.9781 10.9652L24.5493 10.708L24.9781 10.9652ZM21.9061 16.0852L22.3348 16.3425L21.9061 16.0852ZM21.9061 4.52812L21.4773 4.78537V4.78537L21.9061 4.52812ZM1.55322 15.4267V5.18668H0.553223V15.4267H1.55322ZM21.4773 4.78537L24.5493 9.90537L25.4068 9.39088L22.3348 4.27088L21.4773 4.78537ZM24.5493 10.708L21.4773 15.828L22.3348 16.3425L25.4068 11.2225L24.5493 10.708ZM2.33322 4.40668H12.5732V3.40668H2.33322V4.40668ZM12.5732 4.40668H20.8085V3.40668H12.5732V4.40668ZM13.0732 3.90668V1.34668H12.0732V3.90668H13.0732ZM20.8085 16.2067H12.5732V17.2067H20.8085V16.2067ZM12.5732 16.2067H2.33322V17.2067H12.5732V16.2067ZM12.0732 16.7067V29.5067H13.0732V16.7067H12.0732ZM12.5732 29.0067H10.0132V30.0067H12.5732V29.0067ZM12.5732 30.0067H15.1332V29.0067H12.5732V30.0067ZM24.5493 9.90537C24.6976 10.1524 24.6976 10.461 24.5493 10.708L25.4068 11.2225C25.7451 10.6588 25.7451 9.95457 25.4068 9.39088L24.5493 9.90537ZM0.553223 15.4267C0.553223 16.4097 1.35016 17.2067 2.33322 17.2067V16.2067C1.90244 16.2067 1.55322 15.8575 1.55322 15.4267H0.553223ZM21.4773 15.828C21.3364 16.0629 21.0825 16.2067 20.8085 16.2067V17.2067C21.4337 17.2067 22.0131 16.8786 22.3348 16.3425L21.4773 15.828ZM22.3348 4.27088C22.0131 3.73473 21.4337 3.40668 20.8085 3.40668V4.40668C21.0825 4.40668 21.3364 4.55043 21.4773 4.78537L22.3348 4.27088ZM1.55322 5.18668C1.55322 4.7559 1.90244 4.40668 2.33322 4.40668V3.40668C1.35016 3.40668 0.553223 4.20361 0.553223 5.18668H1.55322Z"
                fill="#A2A8B8"
              /></svg
          ></span>
          <p>Lost</p>
        </li>
      </ul>
    </div>

    <!-- Contacted Modal -->
    <div
      class="modal fade"
      id="contactedModel1"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="contactedModelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="contactedModelLabel">Contacted</h5>
            <a
              v-if="
                this.$storage.get('auth').user.user_type == 1 ||
                (this.$storage.get('auth').user.user_type == 2 &&
                  this.$storage.get('auth').user.role_id == 4) ||
                this.$storage.get('auth').user.role_id == 5 ||
                this.$storage.get('auth').user.role_id == 7 ||
                this.$storage.get('auth').user.role_id == 8 ||
                this.$storage.get('auth').user.role_id == 10 ||
                this.$storage.get('auth').user.role_id == 12 ||
                this.$storage.get('auth').user.permissions.includes('8')
              "
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><img
                  style="margin-right: -1px"
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <div class="modal-body">
            <div class="add-member">
              <ul class="scheule">
                <li>
                  <a
                    v-on:click="toggleModel('show', 'appt')"
                    class="add-appoi add-sch"
                    href="#"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M13.1992 10.4704C13.4754 10.4704 13.6992 10.2466 13.6992 9.97041C13.6992 9.69427 13.4754 9.47041 13.1992 9.47041L13.1992 10.4704ZM6.59958 9.47041C6.32344 9.47041 6.09958 9.69427 6.09958 9.97041C6.09958 10.2466 6.32344 10.4704 6.59958 10.4704L6.59958 9.47041ZM10.3994 6.67058C10.3994 6.39444 10.1756 6.17058 9.89941 6.17058C9.62327 6.17058 9.39941 6.39444 9.39941 6.67058L10.3994 6.67058ZM9.39941 13.2702C9.39941 13.5464 9.62327 13.7702 9.89941 13.7702C10.1756 13.7702 10.3994 13.5464 10.3994 13.2702L9.39941 13.2702ZM13.1992 9.47041L9.89941 9.47041L9.89941 10.4704L13.1992 10.4704L13.1992 9.47041ZM9.89941 9.47041L6.59958 9.47041L6.59958 10.4704L9.89941 10.4704L9.89941 9.47041ZM9.39941 6.67058L9.39941 9.97041L10.3994 9.97041L10.3994 6.67058L9.39941 6.67058ZM9.39941 9.97041L9.39941 13.2702L10.3994 13.2702L10.3994 9.97041L9.39941 9.97041ZM14.0831 14.1541C11.7725 16.4647 8.0263 16.4647 5.7157 14.1541L5.00859 14.8612C7.70972 17.5624 12.0891 17.5624 14.7902 14.8612L14.0831 14.1541ZM5.7157 14.1541C3.4051 11.8435 3.4051 8.0973 5.7157 5.7867L5.00859 5.07959C2.30747 7.78072 2.30747 12.1601 5.00859 14.8612L5.7157 14.1541ZM5.7157 5.7867C8.0263 3.47609 11.7725 3.47609 14.0831 5.7867L14.7902 5.07959C12.0891 2.37846 7.70972 2.37846 5.00859 5.07959L5.7157 5.7867ZM14.0831 5.7867C16.3937 8.0973 16.3937 11.8435 14.0831 14.1541L14.7902 14.8612C17.4914 12.1601 17.4914 7.78071 14.7902 5.07959L14.0831 5.7867Z"
                          fill="#3151A1"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect
                            width="14"
                            height="14"
                            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 19.7988 9.97046)"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Schedule Appointment</a
                  >
                </li>
                <li>
                  <a
                    v-on:click="toggleModel('show', 'task')"
                    class="add-appoi add-tas"
                    href="#"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M13.1992 10.4704C13.4754 10.4704 13.6992 10.2466 13.6992 9.97041C13.6992 9.69427 13.4754 9.47041 13.1992 9.47041L13.1992 10.4704ZM6.59958 9.47041C6.32344 9.47041 6.09958 9.69427 6.09958 9.97041C6.09958 10.2466 6.32344 10.4704 6.59958 10.4704L6.59958 9.47041ZM10.3994 6.67058C10.3994 6.39444 10.1756 6.17058 9.89941 6.17058C9.62327 6.17058 9.39941 6.39444 9.39941 6.67058L10.3994 6.67058ZM9.39941 13.2702C9.39941 13.5464 9.62327 13.7702 9.89941 13.7702C10.1756 13.7702 10.3994 13.5464 10.3994 13.2702L9.39941 13.2702ZM13.1992 9.47041L9.89941 9.47041L9.89941 10.4704L13.1992 10.4704L13.1992 9.47041ZM9.89941 9.47041L6.59958 9.47041L6.59958 10.4704L9.89941 10.4704L9.89941 9.47041ZM9.39941 6.67058L9.39941 9.97041L10.3994 9.97041L10.3994 6.67058L9.39941 6.67058ZM9.39941 9.97041L9.39941 13.2702L10.3994 13.2702L10.3994 9.97041L9.39941 9.97041ZM14.0831 14.1541C11.7725 16.4647 8.0263 16.4647 5.7157 14.1541L5.00859 14.8612C7.70972 17.5624 12.0891 17.5624 14.7902 14.8612L14.0831 14.1541ZM5.7157 14.1541C3.4051 11.8435 3.4051 8.0973 5.7157 5.7867L5.00859 5.07959C2.30747 7.78072 2.30747 12.1601 5.00859 14.8612L5.7157 14.1541ZM5.7157 5.7867C8.0263 3.47609 11.7725 3.47609 14.0831 5.7867L14.7902 5.07959C12.0891 2.37846 7.70972 2.37846 5.00859 5.07959L5.7157 5.7867ZM14.0831 5.7867C16.3937 8.0973 16.3937 11.8435 14.0831 14.1541L14.7902 14.8612C17.4914 12.1601 17.4914 7.78071 14.7902 5.07959L14.0831 5.7867Z"
                          fill="#3151A1"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect
                            width="14"
                            height="14"
                            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 19.7988 9.97046)"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Task</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Contacted Modal -->

    <!-- Contacted Modal -->
    <div
      class="modal fade"
      id="contactedModel"
      tabindex="-1"
      data-backdrop="static"
      data-keyboard="false"
      role="dialog"
      aria-labelledby="contactedModelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="contactedModelLabel">Contacted</h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <div class="modal-body">
            <div class="add-member how-form">
              <div
                class="form-group mb-3"
                v-if="how_.type == 'call'"
                style="display: flow-root"
              >
                <img
                  class="img-fluid align-middle float-left"
                  src="../../assets/img/Call.svg"
                  alt=""
                />
                <span class="float-left">{{ customer_phone }}</span>
                <button
                  v-if="
                    this.$storage
                      .get('auth')
                      .user.dealer_permissions.indexOf('3') != -1
                  "
                  :disabled="callLoader"
                  v-on:click="makePhoneCall(customer_phone)"
                  type="submit"
                  class="rem-btn clickbtn"
                >
                  <span v-if="callLoader"
                    ><span class="spinner-grow spinner-grow-sm"></span>
                    Loading...</span
                  >
                  <span v-if="!callLoader"> Click to calll</span>
                </button>
              </div>
              <div class="form-group" v-if="how_.type == 'call'">
                <label class="containerw">
                  Answered
                  <input
                    type="radio"
                    value="Answered"
                    name="radio"
                    v-model="how_.status"
                  />
                  <span class="checkmark"></span>
                </label>
                <label class="containerw">
                  Not Answered
                  <input
                    type="radio"
                    value="Not Answered"
                    name="radio"
                    v-model="how_.status"
                  />
                  <span class="checkmark"></span>
                </label>
                <label class="containerw">
                  Bad #
                  <input
                    type="radio"
                    value="Bad #"
                    name="radio"
                    v-model="how_.status"
                  />
                  <span class="checkmark"></span>
                </label>
                <label class="containerw">
                  Voice Mail
                  <input
                    type="radio"
                    value="Voice Mail"
                    name="radio"
                    v-model="how_.status"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="form-group">
                <label>Call Type</label>
                <select class="form-control" v-model="how_.call_type">
                  <option value="">Choose call type</option>
                  <option value="In">In</option>
                  <option value="Out">Out</option>
                </select>
              </div>
              <div class="form-group">
                <label for="inputAddress">Note</label>
                <textarea
                  class="form-control"
                  id=""
                  rows="2"
                  v-model="how_.note"
                  placeholder="Type here..."
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="#"
              class="add-btn"
              data-dismiss="modal"
              aria-label="Cancel"
            >
              Cancel</a
            >
            <button
              :disabled="updatecontectedoader"
              v-on:click="updateContacted('update')"
              type="submit"
              class="rem-btn"
            >
              <span v-if="updatecontectedoader"
                ><span class="spinner-grow spinner-grow-sm"></span>
                Loading...</span
              >
              <span v-if="!updatecontectedoader">Okay</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Contacted Modal -->

    <!-- Why Lost Modal -->
    <div
      class="modal fade"
      id="whyLostModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="Why Lost"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="whyLostModelLabel">Why?</h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <div class="modal-body">
            <div class="add-member">
              <form>
                <div class="form-group">
                  <label for="inputCity">Why</label>
                  <select class="form-control" v-model="why_.why">
                    <option value="">Select reason</option>
                    <option v-for="w in why_options" :value="w.id" :key="w.id">
                      {{ w.option_text }}
                    </option>
                  </select>
                  <div
                    class="validate-error-message"
                    v-if="$vd.why_.why.$hasError === true"
                  >
                    {{ $vd.why_.$errors.why[0] }}
                  </div>
                </div>
                <div class="comment">
                  <label v-if="why_.why != 2" for="comment">Comment</label>
                  <label v-else>Which Dealership</label>
                  <textarea
                    id="comment"
                    class="form-control"
                    v-model="why_.comment"
                  ></textarea>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="#"
              class="add-btn"
              data-dismiss="modal"
              aria-label="Cancel"
            >
              Cancel</a
            >
            <a href="#" class="rem-btn" v-on:click="updateStatus(7)"> Select</a>
          </div>
        </div>
      </div>
    </div>
    <!-- Why Lost Modal -->
  </div>
  <!-- active -tabss -->
</template>
<script>
import $ from "jquery";
import axios from "axios";
import VueDaval from "vue-daval";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import VueNumeric from "vue-numeric";
//import moment from 'moment'
export default {
  name: "leadTabs",
  components: { DatePicker, VueNumeric },
  props: [
    "lead_type",
    "vehicle_id",
    "lead_touch_time_diff",
    "lead_status",
    "lead_sub_status",
    "defaultAssignTo",
    "employeesList",
    "lead_created",
    "lead_touch_status",
    "lead_touch_response_time",
    "customer_phone",
    "customer_id",
    "lead_source",
  ],
  mixins: [VueDaval],
  vdRules: {
    why_: {
      why: { required: true },
    },
  },

  data() {
    return {
      contacted: false,
      solddate: "",
      cashdealstatus: true,
      finance: false,
      lease: false,
      deal: {
        cashdeal: 0,
        finance: 0,
        lease: 0,
        soldfor: "",
        tradein: "",
        acv: "",
        payment: "",
        terms: "",
        apr: "",
        dealtype: 1,
        selling_price: "",
        cash_down: "",
        dtfp: "",
      },
      dl_autolink: "",
      v_autolink: "",
      task: "",
      how_: {
        type: "",
        call_type: "",
        status: "",
        lead_id: this.$route.params.id,
        note: "",
        cus_id: this.customer_id,
      },
      current_status: 0,
      current_sub_status: {},
      why_: { why: "", comment: "" },
      visit: "",
      why_options: {},
      appointments: [],
      aptColors: ["green-meeting", "red-meeting", "blue-meeting"],
      response_time: { d: "", h: "", m: "00", s: "00" },
      t: "",
      subStatus: "",
      vehicleId: "",
      callLoader: false,
      updatecontectedoader: false,
    };
  },
  watch: {
    lead_touch_response_time: function () {
      this.how_.cus_id = this.customer_id;
      clearInterval(this.t);
      
      if (this.lead_touch_status == 0) {
        //this.getResponseTime(this.lead_created)
        if (this.lead_type == 3 && this.lead_source != 138) {
          this.getResponseTime(this.$route.params.id);
        }
      } else {
        this.countdown(this.lead_touch_time_diff);
        //this.response_time.m = this.lead_touch_time_diff
      }
      // if (this.lead_touch_time_diff != undefined && this.lead_touch_time_diff != 'undefined' && this.lead_touch_time_diff != null && this.lead_touch_time_diff != '') {
      //     this.countdown(this.lead_touch_time_diff)
      // }

      // clearInterval(this.t)
      // let diff = this.$options.filters.timeDifference(rt,this.lead_created)
      // let vm = this
      // if (this.lead_touch_status == 1) {
      //     this.countdown(diff)
      // }else{
      //     this.t = setInterval(function() {
      //         ++diff;
      //         vm.countdown(diff)
      //     },1000)
      // }
    },
    lead_status: function (newVal) {
      this.current_status = newVal;
      if (newVal == 6 || newVal == 7) {
        this.visit = "desk";
      } else {
        this.visit = newVal;
      }
    },
    lead_sub_status: function (newSta) {
      this.current_sub_status = newSta;
    },
    vehicle_id: function (params) {
      this.vehicleId = params;
    },
  },
  created() {
    //console.log(this.$storage.get('auth').user)
    this.whyOptions();
    this.getdeal();

    this.getAppointments(this.$route.params.id);
    let vm = this;
    this.$root.$on("action", function (action, data) {
      vm.task = data;
      if (action == "update_touch_status") {
        if (vm.lead_touch_status == 0) {
          vm.lead_touch_status = 1;
          clearInterval(vm.t);
          //vm.getResponseTime(vm.lead_created)
          //setTimeout(function() {

          //vm.lead_touch_response_time = data
          //}, 500)
        }
      } else if (action == "new_appointment") {
        vm.getAppointments(this.$route.params.id);
      } else if (action == "update_lead_status") {
        vm.updateStatusProcess(data);
      } else if (action == "openCallModal") {
        vm.how_.status = "";
        $("#contactedModel").modal("show");
        vm.how_.type = "call";
        vm.how_.note = "";
      } else if (action == "taskoutboundcall") {
        vm.how_.status = "";
        $("#contactedModel").modal("show");
        vm.how_.type = "call";
        vm.how_.note = "";
      }
      // else if (action == "contacted") {
      //   console.log("leadtab");
      //   vm.updateStatus(2);
      //   vm.$store.commit("updateContacted", false);
      // }
    });
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    updateUserBusyStatus(status) {
      axios
        .get("update_user_busy_status/" + status, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            var auth = this.$storage.get("auth");
            if (status == 1) {
              $(".user-active").addClass("Away-now");
              auth.user.busy_status = 1;
              this.$toast.open({
                position: "top-right",
                message: "Your status has been changed to busy",
                type: "info",
              });
            }
            this.$storage.set("auth", auth);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changesubstatus(status, val) {
      this.current_sub_status[status] = val;
      axios
        .post(
          "update_lead_sub_status/" + this.$route.params.id,
          this.current_sub_status,
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.current_sub_status.status = val;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onChnageHandelerVisit(val, event) {
      if (event.target.checked) {
        this.updateStatusProcess(4);
        this.changesubstatus("visit", 1);
      } else {
        this.updateStatusProcess(3);
        this.changesubstatus("visit", 0);
        this.changesubstatus("demo", 0);
      }
    },
    onChnageHandeler(val, event) {
      if (event.target.checked) {
        if (this.$store.state.vehicle) {
          this.updateStatusProcess(5);
          this.changesubstatus("demo", 1);
        } else {
          $("#demo").prop("checked", false);
          $("#demo1").prop("checked", false);
          alert("Vehicle Not Found");
        }
      } else {
        if (this.$store.state.vehicle) {
          this.updateStatusProcess(4);
          this.changesubstatus("demo", 0);
        } else {
          alert("Vehicle Not Found");
        }
      }
    },
    onChnageHandelerdesk(val, event) {
      if (event.target.checked) {
        this.current_sub_status.desk = 1;
        this.changesubstatus("desk", 1);
      } else {
        this.current_sub_status.desk = 0;
        this.changesubstatus("desk", 0);
      }
    },

    changeValue(val) {
      if (val == "cash") {
        this.cashdealstatus = true;
        this.finance = false;
        this.lease = false;
        this.deal.dealtype = 1;
      }
      if (val == "Finance") {
        this.finance = true;
        this.lease = false;
        this.cashdealstatus = false;
        this.deal.dealtype = 2;
      }
      if (val == "Lease") {
        this.finance = false;
        this.lease = true;
        this.cashdealstatus = false;
        this.deal.dealtype = 3;
      }
    },
    getdeal() {
      axios
        .get("get/deal/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.status) {
            this.deal.rebates = res.data.message.l_rebates;
            this.deal.net_trade = res.data.message.l_net_trade;
            this.deal.msrp = res.data.message.l_msrp;
            if (res.data.message.l_solddate) {
              this.solddate = moment(
                new Date(res.data.message.l_solddate)
              ).format("YYYY-MM-DD");
            }

            this.deal.mileage_allowance = res.data.message.l_mileage_allowance;
            this.deal.residual_rate = res.data.message.l_residual_rate;
            this.deal.money_factor = res.data.message.l_money_factor;
            this.deal.lease_terms = res.data.message.l_lease_terms;
            this.deal.cap_cost_reduction =
              res.data.message.l_cap_cost_reduction;
            this.deal.cap_cost = res.data.message.l_cap_cost;
            this.deal.dtfp = res.data.message.l_dtfp;
            this.deal.apr = res.data.message.l_apr;
            this.deal.terms = res.data.message.l_terms;
            this.deal.cash_down = res.data.message.l_cashdown;
            this.deal.selling_price = res.data.message.l_selling_price;
            this.deal.cashdown = res.data.message.l_cashdown;
            this.deal.l_cash_selling_price =
              res.data.message.l_cash_selling_price;
            this.deal.l_cash_cashdown = res.data.message.l_cash_cashdown;
            if (res.data.message.l_deal_type == 2) {
              this.finance = true;
              this.lease = false;
              this.cash = false;
              this.cashdealstatus = false;
              $("#cash_sellingprice").val("");
              $("#cash_cahdown").val("");
            }
            if (res.data.message.l_deal_type == 3) {
              this.lease = true;
              this.finance = false;
              this.cash = false;
              this.cashdealstatus = false;
            }
            if (res.data.message.l_deal_type == 1) {
              this.cashdealstatus = true;
              this.lease = false;
              this.finance = false;
              $("#finance_sellingprice").val("");
              $("#finance_cahdown").val("");
            }
            //  this. = res.data.message.cash_selling_price;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    adddeal() {
      if (this.$store.state.vehicle) {
        this.deal.solddate = moment(new Date(this.solddate)).format(
          "YYYY-MM-DD"
        );
        axios
          .post(
            "addDeal",
            {
              deal: this.deal,
              lead_id: this.$route.params.id,
              vehicleid: this.$store.state.vehicleid,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$storage.get("auth").token,
              },
            }
          )
          .then((res) => {
            console.log(res.data);
            if (res.data.status == "markedassold") {
              this.$toast.open({
                position: "top-right",
                message: res.data.message,
                type: "info",
              });
            } else {
              this.$toast.open({
                position: "top-right",
                message: res.data.message,
              });
              this.updateStatus(6);
              this.getdeal();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        alert("please add vehicle");
      }
    },

    reScheduleApt(apt) {
      this.$root.$emit("action", "reschedule_apt", apt);
    },
    makePhoneCall(customer_phone) {
      if (
        this.$storage.get("auth").user.dealer_permissions.indexOf("3") == -1
      ) {
        this.$root.$emit("action", "openattentionmodal");
        return false;
      }
      this.callLoader = true;
      this.$toast.open({
        position: "top-right",
        message: "Calling Your Cell",
      });
      axios
        .post(
          "call",
          {
            customerphone: customer_phone,
            created_by: this.$storage.get("auth").user.id,
            lead_id: this.$route.params.id,
            name: this.$storage.get("auth").user.name,
            dealr_id: this.$storage.get("auth").user.dealer_id,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.callLoader = false;
            this.$root.$emit("action", "new_activity");
          } else {
            this.$toast.open({
              position: "top-right",
              message: "Something Wrong",
              type: "info",
            });
            this.callLoader = false;
          }
        })
        .catch((err) => {
          this.callLoader = false;
          console.log(err);
        });
    },
    getResponseTime(c_date) {
      if (
        c_date != undefined &&
        c_date != "undefined" &&
        c_date != null &&
        c_date != ""
      ) {
        axios
          .get("get_response_time/" + c_date, {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          })
          .then((res) => {
            if (res.data.success) {
              this.countdown(res.data.success);
              if (res.data.isSetInterval == 1) {
                let vm = this;
                this.t = setInterval(function () {
                  vm.countdown("Increment");
                }, 1000);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    countdown(diff) {
      //console.log("24");
      //console.log(this.response_time);
      if (this.lead_touch_status == 1) {
        var time_difference = this.lead_touch_time_diff.toString().split(".");
        this.response_time.m = time_difference[0];
        this.response_time.s = time_difference[1];
        if (this.response_time.s > 59) {
          this.response_time.s = 0;
          this.response_time.m++;
        }
        return false;
      }
      if (
        diff != undefined &&
        diff != "undefined" &&
        diff != null &&
        diff != ""
      ) {
        if (diff == "Increment") {
          this.response_time.s++;
        } else {
          if (Number.isInteger(diff)) {
            this.response_time.m = diff;
            this.response_time.s = 0;
          } else {
            var time_arr = diff.toString().split(".");
            console.log(time_arr);
            this.response_time.m = time_arr[0];
            this.response_time.s = time_arr[1];
          }
        }

        if (this.response_time.s > 59) {
          this.response_time.s = 0;
          this.response_time.m++;
        }

        // var d = Math.floor((diff / 3600)/24);
        // var h = Math.floor((diff / 3600)-(d*24));
        //var m = Math.floor(diff % 3600 / 60);
        //var s = Math.floor(diff % 3600 % 60);

        //this.response_time.d = d > 0 ? d + ':' : "";
        //this.response_time.h = h > 0 ? ("0" + h).slice(-2) + ':' : "";
        //this.response_time.m = m > 0 ? ("0" + m).slice(-2) + ':' : "00:";
        //this.response_time.s = s > 0 ? ("0" + s).slice(-2) : "00";
        //console.log(this.response_time)
      }
    },
    activaTab(tab) {
      $('.nav-tabs a[href="#' + tab + '"]').tab("show");
      $("html, body").animate(
        {
          scrollTop: $('.nav-tabs a[href="#' + tab + '"]').offset().top,
        },
        1000
      );
    },
    getAppointments(id) {
      axios
        .post(
          "appointments/" + id,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            const data = res.data;
            this.appointments = data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateAptStatus(id, status) {
      //if (tstatus != 'past') {
      axios
        .post(
          "update_apt_status",
          { id: id, status: status, lead_id: this.$route.params.id },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            if (status == 1) {
              $("#show" + id).addClass("okay-bg");
              $("#comp" + id).removeClass("okay-bg");
              $("#miss" + id).removeClass("notok-bg");

              $("#LTshow" + id).addClass("okay-bg");
              $("#LTcomp" + id).removeClass("okay-bg");
              $("#LTmiss" + id).removeClass("notok-bg");

              $("#mainAppt" + id)
                .parent()
                .removeClass("red-meeting green-meeting");
              $("#mainAppt" + id)
                .parent()
                .addClass("blue-meeting");
              $("#LTmainAppt" + id)
                .parent()
                .removeClass("red-meeting green-meeting");
              $("#LTmainAppt" + id)
                .parent()
                .addClass("blue-meeting");

              if (res.data.lead_status < 4) {
                this.$root.$emit("action", "update_lead_status", 4);
              }
            } else if (status == 2) {
              $("#comp" + id).removeClass("okay-bg");
              $("#show" + id).removeClass("okay-bg");
              $("#miss" + id).addClass("notok-bg");
              $("#LTcomp" + id).removeClass("okay-bg");
              $("#LTshow" + id).removeClass("okay-bg");
              $("#LTmiss" + id).addClass("notok-bg");

              $("#mainAppt" + id)
                .parent()
                .removeClass("green-meeting blue-meeting");
              $("#mainAppt" + id)
                .parent()
                .addClass("red-meeting");
              $("#LTmainAppt" + id)
                .parent()
                .removeClass("green-meeting blue-meeting");
              $("#LTmainAppt" + id)
                .parent()
                .addClass("red-meeting");
            } else if (status == 3) {
              $("#show" + id).removeClass("okay-bg");
              $("#comp" + id).addClass("okay-bg");
              $("#miss" + id).removeClass("notok-bg");
              $("#LTshow" + id).removeClass("okay-bg");
              $("#LTcomp" + id).addClass("okay-bg");
              $("#LTmiss" + id).removeClass("notok-bg");

              $("#mainAppt" + id)
                .parent()
                .removeClass("red-meeting blue-meeting");
              $("#mainAppt" + id)
                .parent()
                .addClass("green-meeting");
              $("#LTmainAppt" + id)
                .parent()
                .removeClass("red-meeting blue-meeting");
              $("#LTmainAppt" + id)
                .parent()
                .addClass("green-meeting");
            }
            // if (status == 1) {
            //   $("#comp" + id).addClass("okay-bg");
            //   $("#miss" + id).removeClass("notok-bg");
            //   $("#LTcomp" + id).addClass("okay-bg");
            //   $("#LTmiss" + id).removeClass("notok-bg");
            // } else if (status == 2) {
            //   $("#comp" + id).removeClass("okay-bg");
            //   $("#miss" + id).addClass("notok-bg");
            //   $("#LTcomp" + id).removeClass("okay-bg");
            //   $("#LTmiss" + id).addClass("notok-bg");
            // }
            this.$root.$emit("action", "new_activity");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      //}
    },
    updateContacted(type) {
      if (type == "update") {
        if (
          this.how_.status == "" ||
          this.how_.status == null ||
          this.how_.status == undefined ||
          this.how_.status == "undefined"
        ) {
          alert("Please choose any option.");
        } else if (
          this.how_.call_type == "" ||
          this.how_.call_type == null ||
          this.how_.call_type == undefined ||
          this.how_.call_type == "undefined"
        ) {
          alert("Please Choose Call Type");
        } else {
          this.updatecontectedoader = true;
          axios
            .post("update_contacted", this.how_, {
              headers: {
                Authorization: "Bearer " + this.$storage.get("auth").token,
              },
            })
            .then((res) => {
              if (res.data.success) {
                this.updatecontectedoader = false;
                if (this.task != "") {
                  axios
                    .post(
                      "update_task_status",
                      {
                        id: this.task,
                        status: 1,
                        lead_id: this.$route.params.id,
                      },
                      {
                        headers: {
                          Authorization:
                            "Bearer " + this.$storage.get("auth").token,
                        },
                      }
                    )
                    .then((res) => {
                      if (res.data.success) {
                        this.$root.$emit("action", "getalltask");
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }

                if (this.how_.status == "Answered") {
                  // Update Lead Status
                  if (this.current_status < 2) {
                    this.updateStatusProcess(2);
                  }

                  $("#contactedModel1").modal("show");

                  // Update Touch and Engagement Count
                  if (this.how_.call_type == "In") {
                    this.$store.commit(
                      "updateResponseCount",
                      this.$store.state.engagements + 1
                    );
                  } else if (this.how_.call_type == "Out") {
                    this.$store.commit(
                      "updateTouchesCount",
                      this.$store.state.touches + 1
                    );
                    this.$store.commit(
                      "updateResponseCount",
                      this.$store.state.engagements + 1
                    );
                  }
                } else if (
                  this.how_.call_type == "Out" &&
                  this.how_.status != "Answered"
                ) {
                  this.$store.commit(
                    "updateTouchesCount",
                    this.$store.state.touches + 1
                  );
                }

                // Update Lead Touched Status
                if (this.lead_touch_status != 1) {
                  this.lead_touch_status = 1;
                  this.lead_touch_response_time = res.data.lead_touch_resp_time;
                }

                // Update Note
                if (
                  this.how_.note != "" &&
                  this.how_.note != null &&
                  this.how_.note != undefined &&
                  this.how_.note != "undefined"
                ) {
                  this.$root.$emit("action", "new_note");
                }

                // update Activity
                this.$root.$emit("action", "new_activity");
                this.$root.$emit("action", "getalltask");
                if (res.data.modal) {
                  $("#contactedModel").modal("hide");
                }

                this.how_.status = "";
                this.how_.type = "";
                this.how_.note = "";
                this.how_.call_type = "";
              }
            })
            .catch((err) => {
              this.updatecontectedoader = false;
              console.log(err);
            });
        }
      } else {
        this.how_.status = "";
        $("#contactedModel").modal("show");
        this.how_.type = type;
        this.how_.note = "";
        this.how_.call_type = "";
      }
    },
    toggleModel(action, type) {
      $("#contactedModel").modal("hide");
      $("#contactedModel1").modal("hide");
      if (action == "show") {
        if (type == "appt") {
          if (
            this.$storage.get("auth").user.user_type == 2 &&
            this.$store.state.lostlead != 7
          ) {
            this.$store.commit("updateContacted", true);
          }

          $(".add-appointment").addClass("show-appointments");
        } else if (type == "task") {
          if (
            this.$storage.get("auth").user.user_type == 2 &&
            this.$store.state.lostlead != 7
          ) {
            this.$store.commit("updateContacted", true);
          }
          $(".add-task").addClass("show-add-tasks");
        }
      } else if (action == "hide") {
        if (type == "appt") {
          $(".add-appointment").removeClass("show-appointments");
        } else if (type == "task") {
          $(".add-task").removeClass("show-add-tasks");
        }
      }
    },
    updateSubStatus(status) {
      if (status == "visit" || this.$store.state.vehicle == true) {
        this.current_sub_status[status] = 1;
        axios
          .post(
            "update_lead_sub_status/" + this.$route.params.id,
            this.current_sub_status,
            {
              headers: {
                Authorization: "Bearer " + this.$storage.get("auth").token,
              },
            }
          )
          .then((res) => {
            if (res.data.success) {
              if (status == "visit") {
                this.updateStatus(4);
              } else if (status == "demo") {
                this.updateStatus(5);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        $("#demo,#desk,#demo1,#desk1").prop("checked", false);
        alert("No vehicle found.");
      }
    },
    updateStatusLeadLost(id) {
      if (id == 1 || id == 2 || id == 3 || id == 4 || id == 5) {
        this.updateStatusProcess(id);
      }
    },
    updateStatus(id) {
      if (
        this.lead_status == 7 &&
        this.$storage.get("auth").user.user_type == 1
      ) {
        this.updateStatusLeadLost(id);
      }
      if (id == 3) {
        this.toggleModel("show", "appt");
      }
      if (id > this.current_status) {
        if (id == 7) {
          this.$vd.why_
            .$validate()
            .then(() => {
              this.updateStatusProcess(id);
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (id == 5 || id == 6) {
          if (this.$store.state.vehicle) {
            this.updateStatusProcess(id);
          } else {
            $("#demo,#desk,#demo1,#desk1").prop("checked", false);
            alert("No vehicle found.");
          }
        } else if (id != 3) {
          this.updateStatusProcess(id);
        }
      }
    },
    updateStatusProcess(id) {
      console.log(id);

      if (id == 7) {
        if (this.$storage.get("auth").user.user_type == 2) {
          if (this.$store.state.permission.indexOf("18") == -1) {
            this.$toast.open({
              position: "top-right",
              message: "Only agents with permission can mark the lead lost",
              type: "info",
            });
            return false;
          }
        }
      }
      $("#tab1,#tab2,#tab3,#tab4,#tab5,#tab6,#tab7").removeClass("active");
      $("#tab1,#tab2,#tab3,#tab4,#tab5,#tab6,#tab7").removeClass(
        "original-active"
      );
      for (let index = 1; index <= id; index++) {
        $("#tab" + index).addClass("active");
        if (index == id) {
          $("#tab" + index).addClass("original-active");
        }
      }

      $("#contactedModel").modal("hide");
      $("#whyLostModel").modal("hide");

      axios
        .post(
          "update_lead_status",
          { status: id, lead_id: this.$route.params.id, why: this.why_ },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          if (id == 7) {
            this.$store.commit("updateLostLead", 7);
            this.toggleModel("show", "task");
          }
          if (data.success) {
            this.current_status = id;
            if (id == 6 || id == 7) {
              this.visit = "desk";
            } else {
              this.visit = id;
            }
            if (id == 4) {
              this.updateSubStatus("visit");
              this.$root.$emit("action", "update_appointment_status");
              this.$root.$emit("action", "update_appointments");
            }
            if (id == 5) {
              this.updateUserBusyStatus(1);
              this.updateSubStatus("demo");
              this.$root.$emit("action", "update_appointment_status");
              this.$root.$emit("action", "update_appointments");
            }

            this.$root.$emit("action", "new_activity");
            this.why_ = { why: "" };
            // this.getAutolinkId();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    whyOptions() {
      axios
        .get("why_options")
        .then((res) => {
          if (res.data.success) {
            const data = res.data;
            this.why_options = data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getAutolinkId(){
    //    axios
    //       .get("get/autolinkid/" + this.$route.params.id, {
    //         headers: {
    //           Authorization: "Bearer " + this.$storage.get("auth").token,
    //         },
    //       })
    //       .then((res) => {
    //         if (res.data.status) {
    //           this.dl_autolink = res.data.dl_autoalink
    //           this.v_autolink = res.data.v_autolink
    //           if(this.v_autolink){
    //             this.postautolink();
    //           }
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });

    // },
    // postautolink(){
    //    axios
    //     .post(
    //       "https://autolinkme.com/webservices/crm/delete_vehicle",
    //       { vehicle_id: this.v_autolink,id:this.dl_autolink},
    //       {
    //         headers: {
    //           Authorize: "34c009acd06edcba38f9a0eed1f9468732asdas",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //        console.log(res)
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }
  },
};
</script>
<style scoped>
.clickbtn {
  position: relative;
  left: 14px;
  bottom: 3px;
}
.appo-menu ul li {
  display: inline;
  margin-left: 3px;
}
.tl_btns .active-dropdown {
  min-width: 21rem;
}
.text {
  margin-bottom: 5px;
}
.afteremil-btn {
  margin-top: 30px;
  margin-bottom: 30px;
}
.radiodiv {
  margin-top: 11px;
  margin-bottom: 11px;
}
.deal-summary {
  z-index: 999999999999;
}
.radiobtn {
  margin-left: 5px;
}
.mx-datepicker {
  width: 100%;
}
</style>